import type { FC } from 'react';
import React, { createRef } from 'react';
import { getPlaceholderMask } from '@alfa-bank/site-input/src/helpers';
import cn from 'classnames';

import { useCursorPosition } from './use-cursor-position';
import type { TPhoneInput } from './models';
import { PLACEHOLDER_MASK } from './config';
import { usePhoneInput } from './use-phone-input';

export const PhoneInput: FC<TPhoneInput> = ({
    Input,
    className,
    clear = false,
    dataTestId = 'phoneInput',
    forwardedRef,
    onCancel,
    onChange,
    onFocus,
    onKeyDown,
    styles,
    type = 'tel',
    value: initValue = '',
    withPlaceholder,
    ...rest
}) => {
    const inputRef = forwardedRef || createRef();

    const {
        beforeInputSelection,
        handleCancel,
        handleChange,
        handleFocus,
        handleKeyDown,
        handleMouseUp,
        isDeleteOperation,
        maskOptions,
        value,
    } = usePhoneInput({ type, onCancel, onChange, onFocus, inputRef, onKeyDown, initValue });

    useCursorPosition(
        beforeInputSelection.current,
        inputRef,
        maskOptions,
        isDeleteOperation.current
    );

    return (
        <div className={cn(styles.wrapper, className)}>
            {withPlaceholder && (
                <div className={styles.placeholderWrapper}>
                    <span className={styles.placeholderHidden}>{value}</span>
                    {getPlaceholderMask(value, PLACEHOLDER_MASK)}
                </div>
            )}

            <Input
                /** Если значение в поле совпадает с маской, крестик не показываем */
                clear={!(maskOptions.prefix === value) && clear}
                dataTestId={dataTestId}
                forwardedRef={inputRef}
                type="tel"
                {...rest}
                onCancel={handleCancel}
                onChange={handleChange}
                onFocus={handleFocus}
                onKeyDown={handleKeyDown}
                onMouseUp={handleMouseUp}
                value={value}
            />
        </div>
    );
};
